import { createSelector } from '@reduxjs/toolkit';
import { getBaseUrl } from './config';
import { GlobalState } from '../rootReducer';
import { LOCATION_CHANGE } from 'connected-react-router';

/* reducer */
export const DEFAULT_STATE = {
    currentUrl: {
        pathname: '',
    },
    pastUrl: {
        pathname: '',
    },
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                currentUrl: { ...action.payload.location },
                pastUrl: { ...state.currentUrl },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.route;

export const getCurrentUrl: (state: GlobalState) => any = createSelector(
    stateSelector,
    (state) => state.currentUrl || {}
);

export const getPastUrl: (state: GlobalState) => any = createSelector(stateSelector, (state) => {
    return state.pastUrl || {};
});

export const isServerSideRendered: (state: GlobalState) => boolean = createSelector(
    [getCurrentUrl, getPastUrl],
    (currentUrl, pastUrl) => Boolean(!pastUrl.pathname && currentUrl.pathname)
);

export const getCurrentUrlFromState: (state: GlobalState) => string = createSelector(
    [getCurrentUrl, getBaseUrl],
    (currentUrl, baseUrl) => `${baseUrl}${currentUrl.pathname}${currentUrl.search}`
);
